<template>
    <Modal id="payyo-terminal-registration-modal"
           icon="fa-solid fa-tablet"
           title="PAYYO_REGISTER_DEVICE_MODAL.MODAL_TITLE"
           :cancel="cancel"
           ok-label="PAYYO_REGISTER_DEVICE_MODAL.REGISTER_TERMINAL_BTN"
           :ok="registerDevice"
           :ok-enabled="validForm"
           :ok-spinner="registering">
        <!-- General errors -->
        <div v-if="errorMessage"
             class="alert alert-danger">
            <span class="fa-solid fa-exclamation-circle"></span> {{ errorMessage }}
        </div>

        <div v-if="!errorMessage">
            <form class="form-h"
                  @submit.prevent="submit">
                <!-- Errors specifically to do with saving - probably a data issue. -->
                <div v-if="saveError"
                     class="alert alert-danger">
                    <span class="fa-solid fa-exclamation-circle"></span> {{ saveError }}
                </div>

                <div class="form-group">
                    <label for="payyo-form-data-registration-code"
                           class="control-label">
                        {{ l('PAYYO_REGISTER_DEVICE_MODAL.REGISTRATION_CODE__LABEL') }}
                    </label>
                    <div class="form-h__right">
                        <input id="payyo-form-data-registration-code"
                               v-model="formData.registrationCode"
                               type="text"
                               class="form-control input-lg"
                               :placeholder="registrationCodePlaceholder"
                               minlength="1"
                               maxlength="200">
                        <p class="help-block">
                            {{ l('PAYYO_REGISTER_DEVICE_MODAL.REGISTRATION_CODE__HELP') }}
                        </p>
                    </div>
                </div>

                <div class="form-group">
                    <label for="payyo-form-data-label"
                           class="control-label">
                        {{ l('PAYYO_REGISTER_DEVICE_MODAL.LABEL__LABEL') }}
                    </label>
                    <div class="form-h__right">
                        <input id="payyo-form-data-label"
                               v-model="formData.label"
                               type="text"
                               class="form-control input-lg"
                               :placeholder="labelPlaceholder"
                               minlength="1"
                               maxlength="200">
                    </div>
                </div>
            </form>
        </div>
    </Modal>
</template>

<script>
import Modal from '@/vue/components/Modals/Modal';
import { container } from '@/container';
import { ModalPropsMixin } from '@/vue/mixins/ModalPropsMixin';

export default {
    name: 'PayyoTerminalRegistrationModal',

    components: { Modal },

    mixins: [
        ModalPropsMixin,
    ],

    props: {
        countryCode: {
            type: String,
            required: true,
        },
    },

    data() {
        return {
            formData: {
                registrationCode: null,
                label: null,
            },
            errorMessage: null,
            saveError: null,
            /**
             * An array of optional form keys.
             * Note there are currently no optional form fields but this may change again.
             *
             * {string[]}
             */
            optionalFields: [],
            /**
             * An array of required form keys.
             * All fields are required apart from the optionalFields.
             *
             * {string[]}
             */
            requiredFields: [],
            validForm: false,
            registering: false,
        };
    },

    computed: {
        labelPlaceholder: () => {
            return container.langService.getText('PAYYO_REGISTER_DEVICE_MODAL.LABEL__PLACEHOLDER');
        },

        registrationCodePlaceholder: () => {
            return container.langService.getText('PAYYO_REGISTER_DEVICE_MODAL.REGISTRATION_CODE__PLACEHOLDER');
        },
    },

    watch: {
        formData: {
            handler(newFormData) {
                for (const requiredField of this.requiredFields) {
                    if (!newFormData[requiredField] || newFormData[requiredField].trim() === '') {
                        this.validForm = false;
                        return;
                    }
                }
                this.validForm = true;
            },
            deep: true,
        },
    },

    async created() {
        try {
            container.payyoDriver.init(false);

            // Set up the form validation.
            const allFields = Object.keys(this.formData);
            this.requiredFields = allFields.filter((o) => !this.optionalFields.includes(o));
        } catch (error) {
            this.errorMessage = error.message;
        }
    },

    methods: {
        async registerDevice() {
            this.registering = true;
            try {
                const registrationData = {
                    registration_code: this.formData.registrationCode,
                    label: this.formData.label,
                    merchant_id: container.payyoDriver.config.merchantId,
                };

                console.log('Payyo registrationData', registrationData);
                container.payyoDriver.registerDevice(registrationData).then(() => {
                    container.toastFactory.successTop(
                        'PAYYO_REGISTER_DEVICE_MODAL.DEVICE_REGISTERED',
                    );
                    this.resolve();
                }).catch((error) => {
                    // This is the most likely error so let's specifically provide a better error message.
                    if (error.message.trim() === 'unable to create reader') {
                        error.message = container.langService.getText('PAYYO_REGISTER_DEVICE_MODAL.UNABLE_TO_CREATE_READER');
                    }
                    this.registering = false;
                    this.saveError = error.message;
                });
            } catch (error) {
                this.registering = false;
                this.errorMessage = error.message;
            }
        },

    },
};
</script>

<style lang="less" scoped>
@import "../../../../less/variables.less";

@media (max-width: @mobile-max) {
    .form-h__right {
        flex-direction: column;
    }
}

</style>
